import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_IS_CHECK_SCHEDULE,
  CONTRACT_SETUP_SCHEDULE_SAVE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

interface ContractSetupScheduleState {
  isCheckSchedule: boolean;
  scheduledDate: string | null;
}

const initialState: ContractSetupScheduleState = {
  isCheckSchedule: false,
  scheduledDate: null,
};

export default function reducer(
  state: ContractSetupScheduleState = initialState,
  action: ContractSetupAction
): ContractSetupScheduleState {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return initialState;
    case CONTRACT_SETUP_SCHEDULE_SAVE:
      return {
        isCheckSchedule: true,
        scheduledDate: action.payload.scheduledDate,
      };
    case CONTRACT_SETUP_IS_CHECK_SCHEDULE:
      return {
        ...state,
        isCheckSchedule: action.payload.isCheckSchedule,
      };
    default:
      return state;
  }
}
